/* eslint-disable no-undef */
import { Input, Modal, message, Form } from "antd";
import React, { Component } from "react";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import "./SystemConfig.css";
import { SystemConfigService } from "../../services/systemConfig/SystemConfigService";
import "antd/dist/antd.css";
import { handleError } from "../../utils/ErrorHandlers";
import "../../components/general/drawer/AdaptiveDrawer.css";
import { Translation } from "react-i18next";
import i18next from "i18next";
class EditConfig extends Component {
  constructor(props) {
    super(props);
    this.systemConfigService = new SystemConfigService();
    this.state = {
      isFetchingEdit: false,
      visible: false,
      value: "",
    };
  }

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          await this.EditSystemConfig(values);
        }
      } catch (e) {
        this.setState({ visible: false });
        handleError(e);
      }
    });
  };

  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };

  validateValue(text) {
    this.setState({ value: text });
  }

  componentDidMount() {}

  async EditSystemConfig(row) {
    try {
      this.setState({ isFetchingEdit: true });

      // if (
      //   this.props.configCategory == "SYSTEM_PROP" &&
      //   this.props.Key == "LOGGING_LEVEL"
      // ) {
      //   let data = await this.systemConfigService.editLoggingLevel(
      //     this.props.context.session_id,
      //     this.state.value === "" ? this.props.value : row.value
      //   );
      // }
      let data = await this.systemConfigService.editSystemConfigService(
        this.props.context.session_id,
        {
          key: this.props.Key,
          value: this.state.value === "" ? this.props.value : row.value,
          configCategory: this.props.configCategory,
        }
      );

      this.setState({ isFetchingEdit: false });

      this.props.onCancel();
      this.props.getAllSystemConfigs();
      if (data.statusCode != 0) {
        message.error(data.statusMsg);
      } else {
        message.success(i18next.t("System Config edited successfully"));
      }
    } catch (e) {
      this.setState({ isFetchingEdit: false });
      handleError(e);
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {};

    return (
      <Translation>
        {(t) => (
          <Modal
            destroyOnClose={true}
            title={t("Edit Configuration")}
            visible={this.props.visible}
            onOk={this.handleOk}
            onCancel={() => this.props.onCancel()}
            okText={t("OK")}
            cancelText={t("Cancel")}
          >
            <Form {...formItemLayout}>
              <Form.Item label={this.props.Key}>
                {getFieldDecorator("value", {
                  initialValue: this.props.value,
                  rules: [
                    {
                      type: "string",
                      message: t("The input is not valid "),
                    },
                    {
                      required: true,
                      message: t("Please enter configuration value"),
                    },
                  ],
                })(
                  <Input onChange={(e) => this.validateValue(e.target.value)} />
                )}
              </Form.Item>
            </Form>
          </Modal>
        )}
      </Translation>
    );
  }
}

export default Form.create()(withSharedStateConsumer(EditConfig));
